<div class="toast" *ngIf="toastMessage">{{ toastMessage }}</div>
<div class="studio">
  <header class="studio__bar">
    <div class="brand">
      <span class="brand__mark">
        <!-- <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M3 6l9 6 9-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
          <rect x="3" y="5" width="18" height="14" rx="2" stroke="currentColor" stroke-width="2" />
        </svg> -->
        <img class="brand__logo" src="assets/logo_2.png" alt="RedLeaf Softwares & Services LLP" width="30" height="30">
      </span>
      <div class="brand__text">
        <span class="brand__name">RedLeaf Softwares &amp; Services LLP</span>
        <span class="brand__tag">Campaign studio</span>
      </div>
    </div>
    <div class="bar__count">
      <span class="bar__count-num">{{ recipients.length }}</span>
      <span class="bar__count-label">recipients queued</span>
    </div>
  </header>

  <div class="studio__grid">

    <!--  COMPOSE PANEL  -->
    <section class="panel panel--compose">

      <div class="field">
        <label>Subject line</label>
        <input type="text" placeholder="Give your campaign a subject line" [(ngModel)]="subject" name="subject" />
      </div>

      <div class="field">
        <label>Recipients</label>
        <div class="chip-field">
          <span class="chip" *ngFor="let r of recipients" [class.chip--invalid]="!isValidEmail(r.email)">
            <span class="chip__avatar">{{ (r.name || r.email).charAt(0).toUpperCase() }}</span>
            <span class="chip__text">
              <span class="chip__name" *ngIf="r.name">{{ r.name }}</span>
              <span class="chip__email">{{ r.email }}</span>
            </span>
            <button type="button" class="chip__remove" (click)="removeRecipient(r.id)" aria-label="Remove recipient">
              <svg width="10" height="10" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />
              </svg>
            </button>
          </span>
          <input type="text" class="chip-field__input" placeholder="name@company.com, then Enter"
            [(ngModel)]="recipientDraft" name="recipientDraft" (keydown)="onRecipientKeydown($event)"
            (paste)="onRecipientPaste($event)" (blur)="commitRecipientDraft()" />
        </div>
        <p class="field__hint" *ngIf="invalidRecipientCount === 0; else invalidHint">
          Paste a list or add one at a time — comma, space, or Enter all work.
        </p>
        <ng-template #invalidHint>
          <p class="field__hint field__hint--error">{{ invalidRecipientCount }} address(es) don't look valid.</p>
        </ng-template>
      </div>

      <div class="field">
        <label>Or import from Excel</label>
        <div class="dropzone dropzone--excel" (click)="triggerExcelDialog()">
          <span class="dropzone__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M4 4h16v16H4z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              <path d="M4 10h16M9 4v16" stroke="currentColor" stroke-width="1.6" />
            </svg>
          </span>
          <span class="dropzone__text">Click to upload an <strong>Excel file</strong> — Name, Email columns</span>
          <input #excelInput type="file" hidden accept=".xlsx,.xls,.csv" (change)="onExcelSelected($event)" />
        </div>
        <p class="field__hint" *ngIf="lastImportSummary">{{ lastImportSummary }}</p>
      </div>

      <div class="field">
        <label>Message</label>
        <div class="editor">
          <div class="editor__toolbar">
            <button type="button" class="editor__btn" (click)="exec('bold')" title="Bold">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M6 4h7a4 4 0 010 8H6zM6 12h8a4 4 0 010 8H6z" stroke="currentColor" stroke-width="2"
                  stroke-linejoin="round" />
              </svg>
            </button>
            <button type="button" class="editor__btn" (click)="exec('italic')" title="Italic">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M10 4h6M8 20h6M14 4l-4 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
            <button type="button" class="editor__btn" (click)="exec('underline')" title="Underline">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M6 4v8a6 6 0 0012 0V4M4 20h16" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
            <span class="editor__divider"></span>
            <button type="button" class="editor__btn" (click)="exec('insertUnorderedList')" title="Bulleted list">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <circle cx="4.5" cy="6" r="1.4" fill="currentColor" />
                <circle cx="4.5" cy="12" r="1.4" fill="currentColor" />
                <circle cx="4.5" cy="18" r="1.4" fill="currentColor" />
                <path d="M9 6h11M9 12h11M9 18h11" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
            <button type="button" class="editor__btn" (click)="exec('createLink', 'https://')" title="Insert link">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M9 15l6-6M10 6l1-1a4 4 0 015.5 5.5l-1 1M14 18l-1 1a4 4 0 01-5.5-5.5l1-1" stroke="currentColor"
                  stroke-width="2" stroke-linecap="round" />
              </svg>
            </button>
            <button type="button" class="editor__btn" *ngIf="!bodyImageFile" (click)="triggerBodyImageDialog()"
              title="Insert image">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <rect x="3" y="3" width="18" height="18" rx="2" stroke="currentColor" stroke-width="1.6" />
                <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" />
                <path d="M21 15l-5-5L5 21" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              </svg>
            </button>
            <input #bodyImageInput type="file" hidden accept="image/*" (change)="onBodyImageSelected($event)">
          </div>
          <div #bodyEditor class="editor__surface" contenteditable="true" data-placeholder="Write your campaign copy…"
            (input)="syncBody()" (paste)="onBodyPaste($event)">
          </div>
        </div>
      </div>

      <div class="field">
        <label>Attachment</label>
        <div class="dropzone" [class.dropzone--active]="isDragging" (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave()" (drop)="onDrop($event)" (click)="triggerFileDialog()">
          <span class="dropzone__icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M21 11l-9 9a5 5 0 01-7-7l9-9a3.5 3.5 0 015 5l-9 9a2 2 0 01-3-3l8-8" stroke="currentColor"
                stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
          <span class="dropzone__text">Drop a file here, or <strong>browse</strong></span>
          <input #fileInput type="file" hidden multiple (change)="onFilesSelected($event)" />
        </div>
        <div class="attachment-list" *ngIf="attachments.length">
          <div class="attachment" *ngFor="let a of attachments">
            <span class="attachment__icon">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M6 2h9l5 5v15H6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                <path d="M15 2v5h5" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              </svg>
            </span>
            <span class="attachment__name">{{ a.name }}</span>
            <span class="attachment__size">{{ a.sizeLabel }}</span>
            <button type="button" class="attachment__remove" (click)="removeAttachment(a.id)"
              aria-label="Remove attachment">×</button>
          </div>
        </div>
      </div>

      <div class="compose-actions">
        <p class="compose-actions__note" *ngIf="!canSend && !isSending">
          Add a subject, a message, and at least one valid recipient to send.
        </p>
        <button type="button" class="send-button" [class.send-button--sending]="isSending" [disabled]="!canSend"
          (click)="send()">
          <span class="send-button__icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M22 2L11 13M22 2l-7 20-4-9-9-4z" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                stroke-linejoin="round" />
            </svg>
          </span>
          <span class="send-button__label">{{ isSending ? 'Sending…' : 'Send campaign' }}</span>
        </button>
      </div>

      <div class="send-report" *ngIf="isSending || sendComplete">
        <div class="send-report__summary">
          <span class="stat stat--sent">{{ sentCount }} sent</span>
          <span class="stat stat--failed" *ngIf="failedCount">{{ failedCount }} failed</span>
          <span class="stat stat--pending" *ngIf="isSending">
            {{ recipients.length - sentCount - failedCount }} in queue
          </span>
          <button type="button" class="send-report__reset" *ngIf="sendComplete" (click)="resetCampaign()">
            Send another
          </button>
        </div>
        <ul class="send-report__list">
          <li *ngFor="let r of recipients" [class]="'status--' + r.status" [title]="r.errorMessage || ''">
            <span class="status-avatar">{{ (r.name || r.email).charAt(0).toUpperCase() }}</span>
            <span class="status-email">{{ r.name || r.email }}</span>
            <span class="status-icon"></span>
            <span class="status-label">{{ r.status }}</span>
            <span class="status-error" *ngIf="r.errorMessage">{{ r.errorMessage }}</span>
          </li>
        </ul>
      </div>

    </section>

    <!--  LIVE PREVIEW PANEL  -->
    <section class="panel panel--preview">
      <div class="preview-sticky">
        <span class="preview-label">Live preview</span>
        <article class="inbox-card">
          <header class="inbox-card__head">
            <div class="inbox-card__avatar">{{ senderName.charAt(0) }}</div>
            <div class="inbox-card__from">
              <strong>{{ senderName }}</strong>
              <span>{{ senderTag }}</span>
            </div>
            <span class="inbox-card__time">now</span>
          </header>

          <h2 class="inbox-card__subject">{{ subject || 'Your subject line will appear here' }}</h2>

          <div class="inbox-card__to">
            <span class="to__label">To</span>
            <span class="to__avatars" *ngIf="recipients.length">
              <span class="to-avatar" *ngFor="let r of recipients.slice(0, 4)">
                {{ (r.name || r.email).charAt(0).toUpperCase() }}
              </span>
              <span class="to-avatar to-avatar--more" *ngIf="recipients.length > 4">
                +{{ recipients.length - 4 }}
              </span>
            </span>
            <span class="to__empty" *ngIf="!recipients.length">—</span>
          </div>

          <div class="inbox-card__divider"></div>

          <div class="inbox-card__body"
            [innerHTML]="bodyHtml || '&lt;span class=\'inbox-card__placeholder\'&gt;Your message will render here as you type.&lt;/span&gt;'">
          </div>

          <div class="inbox-card__attachments" *ngIf="attachments.length">
            <div class="inbox-card__attachment" *ngFor="let a of attachments">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none">
                <path d="M6 2h9l5 5v15H6z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
                <path d="M15 2v5h5" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
              </svg>
              {{ a.name }} <span>{{ a.sizeLabel }}</span>
            </div>
          </div>
        </article>
      </div>
    </section>

  </div>
</div>